export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface Notification {
  id: string;
  type: NotificationType;
  message: string;
  title?: string;
  duration?: number; // milliseconds, 0 = no auto-dismiss
}

export interface NotificationOptions {
  title?: string;
  duration?: number;
}

// Default durations in milliseconds
export const DEFAULT_NOTIFICATION_DURATION = {
  success: 3000,
  error: 5000,
  warning: 4000,
  info: 3000
};
